import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelityComponentsChart',
    label: 'Fidelity Components Chart',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
